import React from 'react';

function MyComponent(props) {

    return (
        <div className='text-center mt-10'>
            Pay Directly with
        </div>
    );
}

export default MyComponent;